export const login = {
    headline: 'Einloggen',
    sectionLabel: 'Kundenbereich',
    inputLabels: {
        userNameOrEmail: 'Nutzername oder E-Mail',
        password: 'Passwort',
        oldPassword: 'Aktuelles Passwort',
        newPassword: 'Neues Passwort',
        repeatPassword: 'Passwort wiederholen',
    },
    mainActions: {
        login: 'Anmelden',
        logout: 'Abmelden',
        register: 'Registrieren',
        forgotPassword: 'Passwort vergessen',
        resetPassword: 'Passwort zurücksetzen',
    },
    messages: {
        loginFailed: 'Benutzername und Passwort stimmen nicht überein.',
        membersOnly: '(nur registrierte Nutzer)',
        passwordResetSuccess: {
            header: 'Passwort zurückgesetzt',
            body: 'Ihr Passwort wurde zurückgesetzt. Sie können sich nun mit Ihrem neuen Passwort einloggen',
        },
    },
};
